<template>
  <div :key="index">
    <div :style="
    'padding:' + options.data.pageCss.page_css_padding + 
    ';margin:' + options.data.pageCss.page_css_margin + 
    ';border-radius:' + options.data.pageCss.page_css_radius + 
    'px;'+options.data.pageCss.myCss" class="mapBox">
      <div class="map_container_home">
        <div id="map_container"></div>
      </div>
    </div>
  </div>

</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "mapBox",
  props: ["index"],
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["okForm"]),
    ...mapGetters(["workPlace"]),
    options() {
      return this.okForm[this.index]
        ? this.okForm[this.index].options
        : { data: this.workPlace.pageTitle.data };
    },
  },
  created() {
  },
  mounted() {
    this.$nextTick(() => {
      this.initMap();  // 把地图初始化逻辑移到一个方法中
    });
  },
  methods: {
    goUrl_map() {
      console.log("goUrl_map");
    },
    initMap() {
      let _this = this;
      var defaultLatLng;

      if (_this.options.data.lat && _this.options.data.lng) {
        defaultLatLng = new qq.maps.LatLng(_this.options.data.lat, _this.options.data.lng);
      } else {
        defaultLatLng = new qq.maps.LatLng(31.2397, 121.5007);  // 东方明珠
      }

      var map_container = new qq.maps.Map(document.getElementById("map_container"), {
        center: defaultLatLng,
        zoom: 15
      });

      var customIcon = new qq.maps.MarkerImage(
        'https://www.cndmcloud.com/storage/setmeet/2025-06/83jyCkUBGttegKWUAGhrKEabyTlsIevMJ6G0Vn26.png',
        new qq.maps.Size(40, 40),
        new qq.maps.Point(0, 0),
        new qq.maps.Point(20, 40)
      );

      var marker = new qq.maps.Marker({
        position: defaultLatLng,
        map: map_container,
        icon: customIcon
      });

      const textLength = this.options.data.db.length | 0; // 文字字数
      const fontSize = 16;
      const offsetX = -(textLength * fontSize) / 2;
      const offsetY = -65;


      // 红色文字标签
      var label = new qq.maps.Label({
        position: defaultLatLng,
        map: map_container,
        content: _this.options.data.db,
        offset: new qq.maps.Size(offsetX, offsetY)
      });

      label.setStyle({
        color: "#000",
        fontSize: "16px",
        fontWeight: "bold",
        backgroundColor: 'transparent',
        border: 'none',
      });

      // 点击打开手机地图导航（高德 / 腾讯 / 苹果）
      qq.maps.event.addListener(marker, 'click', function () {
        const lat = defaultLatLng.getLat();
        const lng = defaultLatLng.getLng();
        const name = encodeURIComponent(_this.options.data.db);  // 可换成实际名称 
        _this.navToMap(lat, lng, name, 2);
      });

      // 点击打开手机地图导航（高德 / 腾讯 / 苹果）
      qq.maps.event.addListener(label, 'click', function () {
        const lat = defaultLatLng.getLat();
        const lng = defaultLatLng.getLng();
        const name = encodeURIComponent(_this.options.data.db);  // 可换成实际名称
        _this.navToMap(lat, lng, name, 2);
      });
    },
    navToMap(lat, lng, name, type) {
      let self = this
      let url
      const u = navigator.userAgent
      //判断ios
      const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      //判断Android
      const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1
      if (isIOS) {
        switch (type) {
          case 1: //百度地图
            url = `http://api.map.baidu.com/marker?location=${lat},${lng}&title=${name}&content=${name}&output=html`
            break
          case 2: //高德地图
            url = `http://uri.amap.com/marker?position=${lng},${lat}&name=${name}&src=mypage&coordinate=gaode&callnative=0`
            break
          case 3: //腾讯地图
            url = `http://apis.map.qq.com/uri/v1/marker?marker=coord:${lat},${lng};addr:${name}`
            break;
          default:
            break
        }
      } else {
        switch (type) {
          case 1: //百度地图
            url = `http://api.map.baidu.com/marker?location=${lat},${lng}&title=${name}&content=${name}&output=html`
            break
          case 2: //高德地图
            url = `http://uri.amap.com/marker?position=${lng},${lat}&name=${name}&src=mypage&coordinate=gaode&callnative=0`
            break
          case 3: //腾讯地图
            url = `http://apis.map.qq.com/uri/v1/marker?marker=coord:${lat},${lng};addr:${name}`
            break;
          default:
            break
        }
      }
      window.location.href = url;
      //window.open(url);  
    }


  },
};
</script>

<style lang="less" scoped>
.mapBox {
  aspect-ratio: 16 / 9;
  background-color: #fff;
  .map_container_home {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  #map_container {
    width: 100%;
    height: 100%;
  }
}
</style> 